module.exports = function () {
    $(document).ready(function () {

        var helper = require('./helper');
        var AjaxController = require('./services/AjaxController');

        var $guardianCheckbox = $('.js-guardian-change-field');

        $guardianCheckbox.on('click', function(){
            var $this = $(this),
                val,
                guardianId = $this.data('guardian'),
                name = $this.attr('name'),
                url = '/api/guardians/change-field',
                data;

            val = ($this.is(':checked')) ? 1 : 0;

            data = {
                guardianId: guardianId,
                value: val,
                field: name
            };

            /** Define error callback */
            var success = function (response) {
            }

            /** Define error callback */
            var error = function (response) {
                console.log('Error');
            }

            /** Send AJAX request */
            AjaxController.prototype.send(url, data, success, error);
        });

    });
}();
